import { render, staticRenderFns } from "./InvoicesBoard.vue?vue&type=template&id=c11ed176&scoped=true"
import script from "./InvoicesBoard.vue?vue&type=script&lang=js"
export * from "./InvoicesBoard.vue?vue&type=script&lang=js"
import style0 from "./InvoicesBoard.vue?vue&type=style&index=0&id=c11ed176&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c11ed176",
  null
  
)

export default component.exports